import React, { Component } from "react";
import { connect } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, ElementsConsumer, PaymentElement } from "@stripe/react-stripe-js";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
} from "containers/MultistepForm/selectors";
import { finishApplication } from "containers/MultistepForm/actions";
import { tokenSelector } from "../../../../EmbeddableWidget/selectors";
import { ProvidersApi } from "../../../../../api/providers";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

class StripePaymentForm extends Component {
  state = {
    submitting: false,
    error: null,
  };

  handleSubmit = async () => {
    const { stripe, elements, offer, token, finishApplication } = this.props;

    if (!stripe || !elements) {
      return;
    }

    this.setState({ submitting: true, error: null });

    try {
      const { error, setupIntent } = await stripe.confirmSetup({
        elements,
        redirect: "if_required",
      });

      if (error) {
        this.setState({ error: error.message, submitting: false });
        return;
      }

      await ProvidersApi.kafeneSignContract(token, {
        app_id: offer.app_id,
        payment_method: setupIntent.payment_method,
      });

      finishApplication();
    } catch (err) {
      const errorMessage = err.data?.reason
        || err.data?.message
        || "Something went wrong. Please try again.";
      
      this.setState({
        error: errorMessage,
        submitting: false,
      });
    }
  };

  render() {
    const { stripe, loading } = this.props;
    const { submitting, error } = this.state;

    return (
      <div>
        <PaymentElement />
        {error && (
          <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
        )}
        <div className="footer" style={{ marginTop: "20px" }}>
          <BlueBtn
            loading={loading || submitting}
            onClick={this.handleSubmit}
            disabled={!stripe || submitting}
          >
            Sign & Complete
          </BlueBtn>
        </div>
      </div>
    );
  }
}

class KafeneStripePayment extends Component {
  state = {
    clientSecret: null,
    loadingIntent: true,
    error: null,
  };

  componentDidMount() {
    const { offer, token } = this.props;

    ProvidersApi.kafeneCreateSetupIntent(token, { app_id: offer.app_id })
      .then((data) => {
        this.setState({ clientSecret: data.client_secret, loadingIntent: false });
      })
      .catch(() => {
        this.setState({
          error: "Failed to initialize payment. Please try again.",
          loadingIntent: false,
        });
      });
  }

  render() {
    const { loading, offer, token, finishApplication } = this.props;
    const { clientSecret, loadingIntent, error } = this.state;

    return (
      <div className="expanded-block-component bank-data-form-container">
        <div className="bank-data-form-header">
          <h1>Payment Information</h1>
          <p>Please enter your payment card to complete the lease signing.</p>
        </div>

        {loadingIntent && <p>Loading payment form...</p>}

        {error && <p style={{ color: "red" }}>{error}</p>}

        {clientSecret && (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <ElementsConsumer>
              {({ stripe, elements }) => (
                <StripePaymentForm
                  stripe={stripe}
                  elements={elements}
                  offer={offer}
                  token={token}
                  loading={loading}
                  finishApplication={finishApplication}
                />
              )}
            </ElementsConsumer>
          </Elements>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  token: tokenSelector()(state),
  offer: activeStepDataSelector()(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    finishApplication: () => dispatch(finishApplication()),
  };
};

KafeneStripePayment = connect(
  mapStateToProps,
  mapDispatchToProps
)(KafeneStripePayment);

export default KafeneStripePayment;
